import React, { useState, useEffect, useMemo } from 'react';
import { useGlobalSelectedId, useGlobalHoveredId } from '../../data/StatusStore';
import { d2gRound } from '../utilities/Utilities';
import Swarm from '../charts/Swarm';
//import SwarmMeta from '../charts/SwarmMeta';
import HistogramMeta from '../charts/HistogramMeta';
import { onSetActiveDBModuleId, onSetActiveRGModuleId, onSetActiveSTModuleId, onSetActiveModuleId, onSetActiveIndicator, onHoverHistogram, useGlobalActiveGeography, useGlobalActiveIndicator, useGlobalActivePage } from '../../data/StatusStore';
import { index } from 'd3';
import Colors from '../utilities/Colors';

export interface RaceGenderSwarmsChartProps {
  options: any;
  data: any;
  width: string;
  height: number;
  colorClass:string;
}

const RaceGenderSwarms: React.FC<RaceGenderSwarmsChartProps> = ({ options, data, width, height, colorClass }) => {
  
  console.log("B010625 RaceGenderSwarms options", options);
  console.log("B010625 RaceGenderSwarms data", data);
  const [preppedData, setPreppedData] = useState<any>({});
  const [filteredData, setFilteredData] = useState<any>([]);
  const [tooltipData, setTooltipData] = useState<any>([]);
  const [indexLookup, setIndexLookup] = useState<any>({});
  const [maxOfAll, setMaxOfAll] = useState<number>(0);
  const [minOfAll, setMinOfAll] = useState<number>(0);
  const selectedId = useGlobalSelectedId();
  const hoveredId = useGlobalHoveredId();
  const activeGeography = useGlobalActiveGeography();
  const activePage = useGlobalActivePage();
  const _height = '80';
  useEffect(() => {
    if (selectedId){
      prepData();
    }
  }, [selectedId]);

  const prepData = () => {
    if (selectedId) {
      const _filteredData = options.variables.filter((v: any) => {
        if (v.sort.Tooltip_only === "") {
          return { v };
        }
      });
      setFilteredData(_filteredData);
      const _tooltipData = options.variables.filter((v: any) => {
        if (v.sort.Tooltip_only !== "") {
          return { v };
        }
      });
      setTooltipData(_tooltipData);

      const rankedData: any = [];
      const _keyIndexDataArray: any = {};
      let countNA = 0;
      let countALL = 0;
      // Iterate through all geographies in data.dataJSON
      Object.keys(data.dataJSON).forEach((geoId: string) => {
        _filteredData.forEach((v: any) => {
          const value = data.dataJSON[geoId][v.variable];
          if (value !== undefined && value !== null) {
            rankedData.push({ geoId, variable: v.variable, value });
          }
          countALL++;
          if (value === "NA"){
            countNA++;
          }
        });
      });

      // Sort the rankedData by value in descending order
      rankedData.sort((a: any, b: any) => {
        const valueA = a.value === 'NA' ? -Infinity : a.value;
        const valueB = b.value === 'NA' ? -Infinity : b.value;
        return valueA - valueB;
      });
      //console.log("B042525 rankedData", rankedData)
      // Assign index to each entry and build keyIndexDataArray
      rankedData.forEach((item: any, index: number) => {
        item.index = index;
        if (!_keyIndexDataArray[item.variable]) {
          _keyIndexDataArray[item.variable] = {};
        }
        
        _keyIndexDataArray[item.variable][item.geoId] = item;
      });

      // Save the keyIndexDataArray to state
      //data.ALLkeyIndexDataArray = _keyIndexDataArray;
      //console.log("DD042425 data", data);
      //console.log("B042525 _keyIndexDataArray", _keyIndexDataArray);

      //console.log("111624 Stacked Swarms _filteredData", _filteredData);
      //console.log("111624 Stacked Swarms _tooltipData", _tooltipData);
      let _minOfAll:number = Infinity;
      let _maxOfAll:number = -Infinity;
      const _preppedData = _filteredData.map((v: any) => {
        /*console.log("D042425 v", v);
        console.log("D042425 v.variable", v.variable);
        console.log("D042425 data?.meta?.max_value[v.variable]", data?.meta?.max_value[v.variable]);
        console.log("DD042425 data", data);
        console.log("DD042425 data.dataJSON[109][v.variable]", data.dataJSON[109][v.variable]);*/
        
        if (_minOfAll > data?.meta?.min_value[v.variable]){
          _minOfAll = data?.meta?.min_value[v.variable]
        }
        if (_maxOfAll < data?.meta?.max_value[v.variable]){
          _maxOfAll = data?.meta?.max_value[v.variable]
        }
        return { name: v.label, value: data.dataJSON[selectedId][v.variable] };
      });
      setMinOfAll(_minOfAll);
      setMaxOfAll(_maxOfAll);
      setPreppedData({preppedData:_preppedData, rankedData: _keyIndexDataArray, countALL: countALL, countNA: countNA});
    }
  };

  const setIndexes = (index:number, variable:string ) => {
    //console.log("B083124 setIndexes index", index);
    //console.log("B083124 setIndexes variable", variable);
    setIndexLookup((prevIndexLookup: any) => ({
      ...prevIndexLookup, // Spread the existing state
      [variable]: index,       // Add or update the new key/value
    }));
  };

  const onClicked = (variable: string) => {
    if (activePage !== "dashboard") {
      if (activePage === "stories") {
        onSetActiveSTModuleId(options.variables[0].sort.moduleId);
      }else if (activePage === "rg") {
        onSetActiveRGModuleId(options.variables[0].sort.moduleId);
      }else{
        onSetActiveModuleId(options.variables[0].sort.moduleId);
      }
    }else{
      onSetActiveDBModuleId(options.variables[0].sort.moduleId);
    }
    onSetActiveIndicator(variable, options.type.toLowerCase(), options.variables[0].sort.moduleId);
  };
  //const total = preppedData.reduce((acc: number, d: any) => acc + d.value, 0);
  //const gridSize = 10; // 10x10 grid
  //const fontSize = 12; // For dynamic heights --> // Math.min(12, Math.max(8, dimensions.width / 50));
  const fontSize2 = 12; // For dynamic heights --> // Math.min(10, Math.max(8, dimensions.width / 50));
  const containerRef = React.useRef<HTMLDivElement | null>(null);
  // Define the bar width in viewBox units for consistency
  let dataLen = data?.dataArray.GEO_ID ? data?.dataArray.GEO_ID.length : 59;
  const barWidthViewBoxUnits = dataLen
    ? dataLen > 100 
      ? 27 
      : 9
    : 27; // Adjust based on number of bars

  // Memoize the Histogram components
  const memoizedSwarms = useMemo(() => {
    //console.log("C111824 options.variables",options.variables);
    //const _filteredData = options.variables.filter((v: any) => v.sort.Tooltip_only === "");
    //const _tooltipData = options.variables.filter((v: any) => v.sort.Tooltip_only !== "");
    //console.log("DDD112624 filteredData",filteredData);
    //console.log("DD042425 maxOfAll, minOfAll]", maxOfAll, minOfAll);
    //console.log("C111824 _tooltipData",_tooltipData);
    return filteredData.map((d: any, i: number) => {
      //console.log("B120724 d,i",d,i);
      //console.log("B120724 data?.dataArray[d.variable]",data?.dataArray[d.variable]);
      //console.log("B120724 tooltipData",tooltipData);
      return (
        /*<Swarm 
          key={`stacked_hist_${d.variable}_${i}`} 
          dataArray={data?.dataArray[d.variable]}
          histMax={data?.meta?.max_value[d.variable]}
          histNA={data?.meta?.na_count[d.variable]} 
          histLength={data?.meta?.length[d.variable]} 
          chartId={`${d.variable}_stacked_hist`}
          height={_height}
          width={'calc(100%)'}
          paddingLeft={'0px'}
          paddingRight={'0px'}
          tooltips={false}
          colorClass={colorClass}
          data={data}
          indicator={d}
        />*/
        <Swarm 
          key={`stacked_swarm_${d.variable}_${i}`} 
          data={data}
          dataArray={data?.dataArray[d.variable]}
          histMax={maxOfAll}
          //histMax={data?.meta?.max_value[d.variable]}
          histMin={minOfAll}
          //histMin={data?.meta?.min_value[d.variable]}
          histNA={data?.meta?.na_count[d.variable]} 
          histLength={data?.meta?.length[d.variable]}  
          chartId={`${d.variable}_stacked_swarm`}
          colorClass={colorClass}
          indicator={d}
          labelOnly={tooltipData}
          options={options}
          context={"race and gender"}
          preppedData={preppedData}
        />
      );
    });
  }, [filteredData, data, maxOfAll, minOfAll, activeGeography, preppedData]);

  return (
    <div style={{ position: "relative", width, height }}>
        {filteredData.map((d: any, i: number) => {
          let selectedIndex = 0;
          let nextSelectedIndex = 0;
          let hoveredIndex = 0;
          let nextHoveredIndex = 0;
          let selectedBarHeight = 0;
          let hoveredBarHeight = 0;
          let _selected = null;
          let _hovered = null;
          if (d && data?.dataArray[d.variable]) {
            //console.log("083124 data?.dataArray[d.variable]", data?.dataArray[d.variable]);
            //console.log("083124 data?.keyIndexDataArray[d.variable]", data?.keyIndexDataArray[d.variable]);
            if (selectedId) {
              //console.log("083124 data?.keyIndexDataArray[d.variable]", data?.keyIndexDataArray[d.variable][selectedId]);
              _selected = data?.keyIndexDataArray[d.variable][selectedId];
              /*selectedIndex = _selected?.index;
              let _nextSelected = options.variables[i+1] ? data?.keyIndexDataArray[options.variables[i+1].variable][selectedId] : null;
              nextSelectedIndex = _nextSelected ? _nextSelected.index : 0;
              selectedBarHeight = _nextSelected
                ? _nextSelected.value === "NA" ? 0 : (_nextSelected.value / data?.meta.max_value[options.variables[i+1].variable]) * parseFloat(_height)
                : 0; */
            }
            if (hoveredId) {
              //console.log("083124 data?.keyIndexDataArray[d.variable]", data?.keyIndexDataArray[d.variable][hoveredId]);
              _hovered = data?.keyIndexDataArray[d.variable][hoveredId];
              /*hoveredIndex = _hovered?.index;
              let _nextHovered = options.variables[i+1] ? data?.keyIndexDataArray[options.variables[i+1].variable][hoveredId] : null;
              nextHoveredIndex = _nextHovered ? _nextHovered.index : 0;
              hoveredBarHeight = _nextHovered
                ? _nextHovered.value === "NA" ? 0 : (_nextHovered.value / data?.meta.max_value[options.variables[i+1].variable]) * parseFloat(_height)
                : 0;*/
            }
            //console.log("083124 data", data);
            //console.log("083124 d", d);
          }
          //console.log("E083124 hoveredBarHeight", hoveredBarHeight);
          //console.log("E083124 selectedBarHeight", selectedBarHeight);
          // Define coordinates dynamically based on the position and data
          /*let x1Index = hoveredIndex;
          let x2Index = nextHoveredIndex;
          let x1IndexS = selectedIndex;
          let x2IndexS = nextSelectedIndex; */
          /*let x1 = `calc(${((x1Index) / dataLen) * 100}% + ${10 - (barWidthViewBoxUnits / 2)}px)`; 
          let y1 = `calc(${50}% - ${20}px)`; 
          let x2 = `calc(${(x2Index) / dataLen * 100}% + ${10 - (barWidthViewBoxUnits / 2)}px)`; 
          let y2 = `calc(${100}% - ${hoveredBarHeight - 10}px)`;
          let x1S = `calc(${((x1IndexS) / dataLen) * 100}% + ${10 - (barWidthViewBoxUnits / 2)}px)`; 
          let y1S = `calc(${50}% - ${20}px)`; 
          let x2S = `calc(${(x2IndexS) / dataLen * 100}% + ${10 - (barWidthViewBoxUnits / 2)}px)`; 
          let y2S = `calc(${100}% - ${selectedBarHeight - 10}px)`;*/
          console.log("D010626 d", d);
          console.log("D010626 d.variable", d.variable);
          const endsWithMaleOrAll = typeof d?.variable === 'string' && (d.variable.endsWith('_male') || d.variable.endsWith('_all'));
          console.log("D010626 endsWith", { variable: d.variable, endsWithMaleOrAll });
          return (
            d && data?.dataArray[d.variable] ? (
              <div 
                ref={containerRef} 
                style={{ cursor:'pointer', width: '100%', height: '115px', position: 'relative', display: 'flex', alignItems: 'flex-start', paddingRight: "0px" }}
                key={`stacked-chart-card-hist-${i}`}
                onClick={() => onClicked(d.variable)}
              >
                <div 
                  style={{ 
                    marginLeft: '0px',
                    marginRight: '15px', 
                    fontSize: fontSize2, 
                    lineHeight: `${fontSize2 + 2}px`,
                    width: `240px`, 
                  }}>
                  { i === 0
                  ?<HistogramMeta
                    dataArray={data?.dataArray[d.variable]}
                    data={data}
                    indicator={d}
                    context={"race and gender"}
                  />
                  : null }
                </div>
                <div 
                  style={{ 
                    marginLeft: '0px',
                    marginRight: '0px', 
                    fontSize: fontSize2, 
                    lineHeight: `${fontSize2 + 2}px`,
                    width: `100px`, 
                    paddingTop: "37.5px",
                    display: 'flex',
                    borderBottom: endsWithMaleOrAll ? '2px solid rgb(104,104,104)' : 'none',
                    //borderBottomLeftRadius: "20px",
                    height: "100%",
                  }}>
                    <div style={{ 
                      width: '50px', 
                      height: '100%', 
                      fontWeight: 'bold',
                      textAlign: 'right',
                      paddingRight: '15px',
                      paddingLeft: '0px',
                    }}>
                      {_hovered 
                        ? d2gRound(_hovered.value, { DESCRIPTOR: data.meta["DESCRIPTOR"][d.variable] }) 
                        : _selected 
                          ? d2gRound(_selected.value, { DESCRIPTOR: data.meta["DESCRIPTOR"][d.variable] })
                          : "N/A"}
                    </div>
                    <div style={{ 
                      width: '50px', 
                      height: '100%', 
                      textAlign: 'left',
                    }}>
                       {/*d.label.split("(")[0]*/}
                       {d.sort.rg_label}
                    </div>
                </div>
                <div 
                  style={{ 
                    marginLeft: '0px', 
                    marginRight: '0px', 
                    fontSize: fontSize2, 
                    lineHeight: `${fontSize2 + 2}px`, 
                    width: `calc(100% - 305px)`,// `calc(100% - 350px)`, // if <SwarmMeta> engaged
                    position: "relative",
                    height: "100%",
                    borderBottom: endsWithMaleOrAll ? '2px solid rgb(104,104,104)' : 'none',
                  }}>    
                  {/* Add SVG to draw slanted line 
                  {i + 1  < options.variables.length
                  ? <svg key={`${d.variable}_${selectedId}_${activeGeography }`} width="100%" height={`calc(${200}%`} style={{ position: 'absolute', top: '10px', left: 0, pointerEvents: 'none', zIndex: 1 }}>
                    <line 
                      x1={x1S} y1={y1S} x2={x2S} y2={y2S} 
                      stroke={Colors.highlightSelect} 
                      strokeWidth="1" 
                      opacity={0.5}
                      strokeDasharray="2,2" // Optional: Makes the line dashed
                    />
                    { hoveredId
                    ? <line 
                        x1={x1} y1={y1} x2={x2} y2={y2} 
                        stroke={Colors.highlightHover} 
                        strokeWidth="1" 
                        strokeDasharray="2,2" // Optional: Makes the line dashed
                      />
                      : null}
                  </svg>
                  : null}*/}
                  {memoizedSwarms[i]}
                </div>
              </div>
            ) : null
          );
        })}
    </div>
  );
};

export default RaceGenderSwarms;
